import { render, staticRenderFns } from "./wrong-problem.vue?vue&type=template&id=4e61e1a4&scoped=true&"
import script from "./wrong-problem.vue?vue&type=script&lang=js&"
export * from "./wrong-problem.vue?vue&type=script&lang=js&"
import style0 from "./wrong-problem.vue?vue&type=style&index=0&id=4e61e1a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e61e1a4",
  null
  
)

export default component.exports